export class FavouriteVacancyAddHandler {
    resolve = null;
    reject = null;
    popup = null;

    constructor(popup) {
        this.popup = popup;
        this.handleVacancyAddFormSubmit = this.handleVacancyAddFormSubmit.bind(this);
    }

    addToFavourites(actionUri) {
        return new Promise(async (resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;

            try {
                const data = new FormData();
                data.set('popupRequest', 'true');

                const response = await fetch(actionUri + '?isFavourite=1', {
                    method: 'POST',
                    header: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    body: data,
                });

                if (response.status === 204) {
                    this.finish(true);
                } else {
                    this.popup.setContent(await response.text());
                    this.popup.getElement().addEventListener('submit', this.handleVacancyAddFormSubmit);
                    this.popup.open();
                    if(this.popup.contentElement.getElementsByClassName('g-recaptcha').length > 0){
                        window.grecaptcha.enterprise.render(this.popup.contentElement.getElementsByClassName('g-recaptcha')[0]);
                    }
                    initEnterpriseRecapthca(); // execute recaptcha enterprise on popup
                }
            } catch (error) {
                this.fail(error);
            }
        });
    }

    async handleVacancyAddFormSubmit(e) {
        e.preventDefault();

        try {
            const form = e.target;
            const response = await fetch(form.action, {
                method: 'POST',
                header: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
                body: new FormData(form),
            });
            if (response.status === 204) {
                this.finish(true);
            }

            this.finish(false);
        } catch (error) {
            this.fail(error);
        }
    }

    finish(success) {
        this.resolve(success);
        this.removeEventListeners();
        this.popup.close();
    }

    fail(error) {
        this.reject(error);
        this.removeEventListeners();
        this.popup.close();
    }

    removeEventListeners() {
        this.popup.getElement().removeEventListener('submit', this.handleVacancyAddFormSubmit);
    }
}
